import React, { useState } from 'react'
import WestBreezeImg from '../../assets/join_west.webp'
import WestBreezeImgOne from '../../assets/west_breeze_img.jpg'
import WestBreezeImgTwo from '../../assets/west_breeze_img-2.jpg'
import { about_roots, about_togather, about_traveller } from '../../assets/updated_assests/assets'

// Utility function to truncate text
const truncateMobile = (text, length = 15) =>
    text.length > length ? text.slice(0, length) + "..." : text;

const Roots = () => {
    const [roots, setRoots] = useState(true)
    const [born, setBorn] = useState(true)
    const [journery, setJournery] = useState(true)
    return (
        <div className='max-w-[1250px] mx-auto px-4 py-16' >
            <div className="flex items-center w-fit bg-bgprimary border-[6px] border-bgprimary">
                <button className={`p-3 text-green text-sm font-bold font-quicksand ${roots ? 'bg-bgprimary' : 'bg-aths'} `} onClick={() => setRoots(true)} >Our Roots</button>
                <button className={`p-3 text-green text-sm font-bold font-quicksand ${roots ? 'bg-aths' : 'bg-bgprimary'} `} onClick={() => setRoots(false)} >Read More</button>
            </div>
            <div className="grid md:grid-cols-3 grid-cols-1 gap-6 border-[6px] border-bgprimary  p-5 w-full mb-12 " style={{ borderRadius: '0px 20px 20px 20px' }} >
                <div className="img w-full h-[380px]  ">
                    <img src={about_roots} className='w-full h-full rounded-[20px] object-cover' alt="" />
                </div>
                <div className="self-center md:col-span-2">
                    <div className="md:pl-24 max-w-[500px]">
                        {roots ?
                            <>
                                <h3 className='text-dark font-roboto-mono font-bold italic text-[40px] tracking-[6%]' >
                                    Our Roots
                                </h3>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    Like everyone who dreams of discovering the world and finding themselves along the way, we all start with nothing but an overwhelming desire for something more.
                                </p>
                            </> :
                            <>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    At 20, with a one-way ticket to Australia, and his first backpack ( and certainly not enough money ), our founder chose the unknown over comfort - a decision that would reshape everything.
                                </p>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    From Southeast Asian beaches to European cities, from South American mountains to African deserts, our 11-year journey taught us what travelers truly need. Westbreeze was born on the road! (and yes, some questionable bunk bed situations), we learned that great travel isn't just about the places you visit, but how well-equipped you are to embrace the journey....
                                </p>
                            </>
                        }

                    </div>


                    {/* <div className=" mt-5 ">
                        <button className='flex  items-center gap-3 border-2 border-dark px-5 py-2 font-quicksand text-dark font-bold text-[16px] bg-white mb-5 ' >Meet Westbreeze </button>
                    </div> */}
                </div>

            </div>


            <div className="flex items-center w-fit bg-bgprimary border-[6px] border-bgprimary">
                <button className={`p-3 text-green text-sm font-bold font-quicksand ${born ? 'bg-bgprimary' : 'bg-aths'} `} onClick={() => setBorn(true)} >
                    <span className="block md:hidden">{truncateMobile("Born from Travelers, for Travelers")}</span>
                    <span className="hidden md:block">Born from Travelers, for Travelers</span>
                </button>
                <button className={`p-3 text-green text-sm font-bold font-quicksand ${born ? 'bg-aths' : 'bg-bgprimary'} `} onClick={() => setBorn(false)} >Read More</button>
            </div>
            <div className="grid md:grid-cols-3 grid-cols-1 gap-6 border-[6px] border-bgprimary  p-5 w-full mb-12 " style={{ borderRadius: '0px 20px 20px 20px' }} >
                <div className="self-center md:col-span-2">
                    <div className="md:pl-24 max-w-[500px]">
                        {born ?
                            <>
                                <h3 className='text-dark font-roboto-mono font-bold italic text-[2.5rem] tracking-[6%]' >
                                    Born from Travelers, for Travelers
                                </h3>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    Westbreeze wasn't born in a boardroom - it emerged from thousands of conversations with fellow travelers across the globe.
                                </p>
                            </> :
                            <>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    In dim hostel rooms and on long train rides, we all shared the same frustrations with our gear and the same dreams of hassle-free travel (and maybe a slight obsession with finding the perfect packing method).
                                    These shared experiences became our blueprint.
                                </p>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    Each feature of our system was inspired by real travelers' needs: from organization solutions to modular designs, from sustainable materials to intuitive functionality -
                                    We brought to life the experience of hundreds of Travellers.

                                </p>
                            </>
                        }

                    </div>


                    {/* <div className=" mt-5 ">
                        <button className='flex  items-center gap-3 border-2 border-dark px-5 py-2 font-quicksand text-dark font-bold text-[16px] bg-white mb-5 ' >Meet Westbreeze </button>
                    </div> */}
                </div>

                <div className="img w-full h-[380px]  ">
                    <img src={about_togather} className='w-full h-full rounded-[20px] object-cover' alt="" />
                </div>


            </div>



            <div className="flex items-center w-fit bg-bgprimary border-[6px] border-bgprimary">
                <button className={`p-3 text-green text-sm font-bold font-quicksand ${journery ? 'bg-bgprimary' : 'bg-aths'} `} onClick={() => setJournery(true)} >A Journey Together</button>
                <button className={`p-3 text-green text-sm font-bold font-quicksand ${journery ? 'bg-aths' : 'bg-bgprimary'} `} onClick={() => setJournery(false)} >Read More</button>
            </div>
            <div className="grid md:grid-cols-3 grid-cols-1 gap-6 border-[6px] border-bgprimary  p-5 w-full mb-12 " style={{ borderRadius: '0px 20px 20px 20px' }} >
                <div className="img w-full h-[380px]  ">
                    <img src={about_traveller} className='w-full h-full rounded-[20px] object-cover' alt="" />
                </div>
                <div className="self-center md:col-span-2">
                    <div className="md:pl-24 max-w-[500px]">
                        {journery ?
                            <>
                                <h3 className='text-dark font-roboto-mono font-bold italic text-[40px] tracking-[6%]' >
                                    A Journey Together
                                </h3>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    Today, we're building more than innovative travel gear - we're creating a movement that makes travel more accessible and meaningful for everyone who dreams of exploring our world.
                                </p>
                            </> :
                            <>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    We're fostering a community where travel knowledge flows freely, where experienced Travellers guide newcomers, and where every journey adds to our collective wisdom.
                                </p>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    Because our greatest lesson wasn't about gear or organization - it was that travel has the power to change lives, open minds, and create connections that span continents.
                                </p>
                                <p className='text-dark font-quicksand font-medium text-[16px] mb-4' >
                                    This is just the beginning of our journey together, and we invite you to be part of this adventure (no awkward hostel introductions required).
                                </p>
                            </>
                        }

                    </div>
                </div>

            </div>
        </div>
    )
}

export default Roots
